import { render, staticRenderFns } from "./EvaluatorsTable.vue?vue&type=template&id=368233f1&"
import script from "./EvaluatorsTable.vue?vue&type=script&lang=js&"
export * from "./EvaluatorsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports